var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 8.15625C2.26758 8.15625 2.74219 8.52539 3.05859 9L25.3125 2.25V22.5L18.3516 20.4434C17.7715 22.6055 15.8203 24.1875 13.5 24.1875C10.7051 24.1875 8.4375 21.9199 8.4375 19.125C8.4375 18.5977 8.54297 18.0176 8.70117 17.543L3.05859 15.8027C2.74219 16.2773 2.26758 16.5938 1.6875 16.5938C0.738281 16.5938 0 15.8555 0 14.9062V9.84375C0 8.94727 0.738281 8.15625 1.6875 8.15625ZM11.127 18.2285C11.0215 18.5449 10.9688 18.8086 10.9688 19.125C10.9688 20.5488 12.0762 21.6562 13.5 21.6562C14.6602 21.6562 15.6621 20.8125 15.9258 19.7051L11.127 18.2285ZM29.5312 0.5625C29.9531 0.5625 30.375 0.984375 30.375 1.40625V23.3438C30.375 23.8184 29.9531 24.1875 29.5312 24.1875H27.8438C27.3691 24.1875 27 23.8184 27 23.3438V1.40625C27 0.984375 27.3691 0.5625 27.8438 0.5625H29.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/Notice.0ff1f954cda066f9535532fa0bc427c2.svg";
export { ForwardRef as ReactComponent };